import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface InPersonCacheProps {
  recordingKey: string | null;
  setRecordingKey: (value: string | null) => void;
  containerUrl: string | null;
  blobPathPrefix: string | null;
  sasToken: string | null;
  sasExpiry: string | null;
  uploadMode: "legacy" | "direct" | null;
  setDirectUploadInfo: (info: {
    containerUrl: string;
    blobPathPrefix: string;
    sasToken: string;
    sasExpiry: string;
  }) => void;
  updateSasToken: (sasToken: string, sasExpiry: string) => void;
  clearDirectUploadInfo: () => void;
}

export const useInPersonCacheStore = create<InPersonCacheProps>()(
  persist<InPersonCacheProps>(
    (set) => ({
      recordingKey: null,
      setRecordingKey: (value) => set({ recordingKey: value }),
      containerUrl: null,
      blobPathPrefix: null,
      sasToken: null,
      sasExpiry: null,
      uploadMode: null,
      setDirectUploadInfo: (info) =>
        set({
          containerUrl: info.containerUrl,
          blobPathPrefix: info.blobPathPrefix,
          sasToken: info.sasToken,
          sasExpiry: info.sasExpiry,
          uploadMode: "direct",
        }),
      updateSasToken: (sasToken, sasExpiry) => set({ sasToken, sasExpiry }),
      clearDirectUploadInfo: () =>
        set({
          containerUrl: null,
          blobPathPrefix: null,
          sasToken: null,
          sasExpiry: null,
          uploadMode: null,
        }),
    }),
    {
      name: "in-person-cache",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        ...state,
        // Exclude SAS credentials from localStorage persistence
        sasToken: null,
        sasExpiry: null,
      }),
    },
  ),
);
